import CaseProceduresContainer from './CaseProceduresContainer';

export default CaseProceduresContainer;
